"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchInput = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Input = require("./Input");
var _FormItem = require("../FormItem/FormItem");
require("./SearchInput.css");
var _excluded = ["onSearch", "value", "label", "error", "size", "className"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var searchIcon = /*#__PURE__*/_react["default"].createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "14",
  viewBox: "0 0 14 14",
  fill: "currentColor"
}, /*#__PURE__*/_react["default"].createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.7375 13.7375C13.3875 14.0875 12.8275 14.0875 12.495 13.7375L9.7825 11.0425C8.7675 11.8125 7.49 12.25 6.125 12.25C2.7475 12.25 0 9.5025 0 6.125C0 2.7475 2.7475 0 6.125 0C9.5025 0 12.25 2.7475 12.25 6.125C12.25 7.49 11.795 8.7675 11.0425 9.7825L13.7375 12.4775C14.0875 12.8275 14.0875 13.3875 13.7375 13.7375ZM6.125 1.75C3.71 1.75 1.75 3.71 1.75 6.125C1.75 8.54 3.71 10.5 6.125 10.5C8.54 10.5 10.5 8.54 10.5 6.125C10.5 3.71 8.54 1.75 6.125 1.75Z"
}));
var clearIcon = /*#__PURE__*/_react["default"].createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "11",
  height: "11",
  viewBox: "0 0 11 11",
  fill: "none"
}, /*#__PURE__*/_react["default"].createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.49318 0C8.53284 0 11 2.45353 11 5.49318C11 8.53284 8.53284 11 5.49318 11C2.45353 11 0 8.53284 0 5.49318C0 2.45353 2.45353 0 5.49318 0ZM5.49318 4.41636L7.04709 2.86245C7.75589 2.15366 8.84634 3.23048 8.13755 3.93928L6.58364 5.49318L8.13755 7.04709C8.84634 7.75589 7.75589 8.84634 7.04709 8.13755L5.49318 6.58364L3.93928 8.13755C3.23048 8.84634 2.15366 7.75589 2.86245 7.04709L4.41636 5.49318L2.86245 3.93928C2.15366 3.23048 3.23048 2.15366 3.93928 2.86245L5.49318 4.41636Z"
}));
var SearchInput = exports.SearchInput = function SearchInput(_ref) {
  var onSearch = _ref.onSearch,
    value = _ref.value,
    label = _ref.label,
    error = _ref.error,
    size = _ref.size,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_FormItem.FormInputItem, {
    label: label,
    error: error,
    size: size,
    className: (0, _classnames["default"])('form-item--search', className)
  }, /*#__PURE__*/_react["default"].createElement(_Input.InputWithPrefix, _extends({
    prefixLabel: searchIcon,
    value: value,
    onChange: function onChange(e) {
      return onSearch(e.target.value);
    },
    className: "form-input--search"
  }, props)), /*#__PURE__*/_react["default"].createElement("button", {
    "aria-hidden": value ? 'false' : 'true',
    className: "form-input--search-clear",
    onClick: function onClick() {
      return onSearch('');
    },
    "aria-label": "Clear search"
  }, !!value && clearIcon));
};